import { FC } from 'react';

// * Props
import RadioButtonProps from './RadioButton.interface';

// * Helpers
import cn from 'classnames';

// * Styles
import styles from "./RadioButton.module.css";

const RadioButton: FC<RadioButtonProps> = ({
  label,
  error,
  className,
  ...rest
}) => {
  return (
    <div className={cn(styles["radio-button"], className)}>
      <div className={styles["radio-button__wrapper"]}>
        <input
          type="radio"
          {...rest}
        />
        {label && (
          <label className={styles["radio-button__label"]}>
            {label}
          </label>
        )}
      </div>
      {error && <p className={styles["radio-button__error"]}>{error}</p>}
    </div>
  );
};

export default RadioButton;
